var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopyPaste = function SvgCopyPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 2.5c0-.46.373-.833.833-.833h8.334v1.666h-7.5V12.5H2.5v-10Zm3.333 3.333c0-.46.373-.833.834-.833h10c.46 0 .833.373.833.833V17.5c0 .46-.373.833-.833.833h-10a.833.833 0 0 1-.834-.833V5.833Zm1.667.833v10h8.333v-10H7.5Z",
    fill: "#7F7B71"
  })));
};

export { SvgCopyPaste as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjUgMi40OTk4NEMyLjUgMi4wMzk2IDIuODczMSAxLjY2NjUgMy4zMzMzMyAxLjY2NjVIMTEuNjY2N1YzLjMzMzE3SDQuMTY2NjdWMTIuNDk5OEgyLjVWMi40OTk4NFpNNS44MzMzMyA1LjgzMzE3QzUuODMzMzMgNS4zNzI5MyA2LjIwNjQzIDQuOTk5ODQgNi42NjY2NyA0Ljk5OTg0SDE2LjY2NjdDMTcuMTI2OSA0Ljk5OTg0IDE3LjUgNS4zNzI5MyAxNy41IDUuODMzMTdWMTcuNDk5OEMxNy41IDE3Ljk2MDEgMTcuMTI2OSAxOC4zMzMyIDE2LjY2NjcgMTguMzMzMkg2LjY2NjY3QzYuMjA2NDMgMTguMzMzMiA1LjgzMzMzIDE3Ljk2MDEgNS44MzMzMyAxNy40OTk4VjUuODMzMTdaTTcuNSA2LjY2NjVWMTYuNjY2NUgxNS44MzMzVjYuNjY2NUg3LjVaIiBmaWxsPSIjN0Y3QjcxIi8+Cjwvc3ZnPgo=";